var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKb2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 519,
    viewBox: "0 0 960 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1131_40889)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 519,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9644,
    width: 905.036,
    height: 519,
    fill: "url(#paint0_linear_1131_40889)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9644,
    y: 401.027,
    width: 905.036,
    height: 57.5754,
    fill: "url(#paint1_linear_1131_40889)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.694,
    y: 137.793,
    width: 160,
    height: 185,
    rx: 5,
    fill: "white",
    stroke: "#28293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.896 165.282L278.687 169.68V165.282L272.207 169.871L271.668 161.502H266.268L265.188 180.4H286.327L284.896 165.282ZM273.225 175.639H270.675V173.088H273.225V175.639ZM280.469 175.639H277.918V173.088H280.469V175.639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.965 158.572C271.965 159.523 270.759 160.789 270.367 160.789C269.699 160.789 266.837 160.789 266.837 160.789C266.837 160.789 263.732 157.616 266.837 156.389C265.532 153.848 271.202 151.346 273.573 153.747C272.541 151.381 283.624 150.481 284.915 155.147C285.622 157.705 278.398 159.979 277.141 158.019C276.063 159.091 273.314 159.545 271.965 158.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.966,
    y: 159,
    width: 30,
    height: 5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.966,
    y: 171.33,
    width: 80,
    height: 5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.562,
    cy: 216.52,
    r: 15.9554,
    fill: "#DFE4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.517 216.52C292.517 214.425 292.104 212.35 291.302 210.414C290.501 208.478 289.325 206.719 287.844 205.238C286.362 203.756 284.603 202.581 282.667 201.779C280.732 200.977 278.657 200.564 276.562 200.564L276.562 216.52H292.517Z",
    fill: "#F1F2F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.694,
    cy: 216.52,
    r: 15.9554,
    fill: "#FCB4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.261 220.844C324.453 221.177 324.934 221.177 325.127 220.844L328.654 214.734C328.847 214.401 328.606 213.984 328.221 213.984H321.167C320.782 213.984 320.541 214.401 320.734 214.734L324.261 220.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.117 218.521L387.59 207.521V224.995L372.117 235.995V218.521Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.117 218.521L356.643 207.521V224.995L372.117 235.995V218.521Z",
    fill: "#3395FF",
    stroke: "#28293D",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.117 218.521L356.644 207.521L372.117 197.414L387.615 207.521L372.117 218.521Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.205 258.529L380.783 258.529",
    stroke: "#DFE4EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.832 278.734L381.41 278.734",
    stroke: "#DFE4EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.205 298.941L380.783 298.941",
    stroke: "#DFE4EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.959 258.014L263.444 280.427V298.941H341.71L318.733 265.912L297.712 276.816L278.959 258.014Z",
    fill: "#DBECFF",
    stroke: "#51A4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.399,
    y: 137.793,
    width: 160,
    height: 185,
    rx: 5,
    fill: "white",
    stroke: "#28293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.891 200.572L475.891 237.729",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.766 220.531L494.766 237.729",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.511 209.617L509.511 237.73",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.847 207.422L524.847 237.73",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.721 225.441L543.721 237.73",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.826 217.971L560.826 237.73",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.161 202.615L576.161 237.729",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.907 231.207L590.907 237.729",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.617 165.282L485.408 169.68V165.282L478.929 169.871L478.389 161.502H472.99L471.91 180.4H493.048L491.617 165.282ZM479.946 175.639H477.396V173.088H479.946V175.639ZM487.19 175.639H484.639V173.088H487.19V175.639Z",
    fill: "#FF6A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.687 158.572C478.687 159.523 477.481 160.789 477.088 160.789C476.42 160.789 473.558 160.789 473.558 160.789C473.558 160.789 470.454 157.616 473.558 156.389C472.254 153.848 477.924 151.346 480.295 153.747C479.262 151.381 490.346 150.481 491.636 155.147C492.344 157.705 485.119 159.979 483.863 158.019C482.785 159.091 480.035 159.545 478.687 158.572Z",
    fill: "#FF6A55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.671,
    y: 159,
    width: 30,
    height: 5,
    fill: "#EBEBF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.671,
    y: 171.33,
    width: 80,
    height: 5,
    fill: "#EBEBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.91 256.529L595.001 256.529",
    stroke: "#DFE4EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.565 276.734L486.565 276.734",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.565 276.734L520.565 276.734",
    stroke: "#DFE4EB",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.91 296.941L595.001 296.941",
    stroke: "#DFE4EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.232,
    y: 137.793,
    width: 160,
    height: 185,
    rx: 5,
    fill: "white",
    stroke: "#28293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.434 165.282L693.225 169.68V165.282L686.746 169.871L686.206 161.502H680.807L679.727 180.4H700.865L699.434 165.282ZM687.763 175.639H685.213V173.088H687.763V175.639ZM695.007 175.639H692.456V173.088H695.007V175.639Z",
    fill: "#FF6A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.504 158.572C686.504 159.523 685.297 160.789 684.905 160.789C684.237 160.789 681.375 160.789 681.375 160.789C681.375 160.789 678.27 157.616 681.375 156.389C680.071 153.848 685.741 151.346 688.112 153.747C687.079 151.381 698.163 150.481 699.453 155.147C700.161 157.705 692.936 159.979 691.68 158.019C690.602 159.091 687.852 159.545 686.504 158.572Z",
    fill: "#FF6A55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721.505,
    y: 159,
    width: 30,
    height: 5,
    fill: "#EBEBF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721.505,
    y: 171.33,
    width: 80,
    height: 5,
    fill: "#EBEBF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 691.1,
    cy: 216.52,
    r: 15.9554,
    fill: "#DFE4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.056 216.52C707.056 214.425 706.643 212.35 705.841 210.414C705.039 208.478 703.864 206.719 702.382 205.238C700.901 203.756 699.142 202.581 697.206 201.779C695.27 200.977 693.195 200.564 691.1 200.564L691.1 216.52H707.056Z",
    fill: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739.232,
    cy: 216.52,
    r: 15.9554,
    fill: "#FCB4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.799 220.844C738.992 221.177 739.473 221.177 739.665 220.844L743.193 214.734C743.385 214.401 743.145 213.984 742.76 213.984H735.705C735.32 213.984 735.08 214.401 735.272 214.734L738.799 220.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.655 218.521L802.129 207.521V224.995L786.655 235.995V218.521Z",
    fill: "#3395FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.655 218.521L771.182 207.521V224.995L786.655 235.995V218.521Z",
    fill: "#51A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.656 218.521L771.182 207.521L786.656 197.414L802.153 207.521L786.656 218.521Z",
    fill: "#DBECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.744 256.529L800.835 256.529",
    stroke: "#DFE4EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.399 276.734L801.49 276.734",
    stroke: "#DFE4EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.744 296.941L800.835 296.941",
    stroke: "#DFE4EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.273 266.327L681.573 296.941H697.983H801.49V256.014L778.699 274.816L747.492 256.014L728.207 274.816L709.273 266.327Z",
    fill: "#DBECFF",
    stroke: "#51A4FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.243 311.614L699.462 293.686V322.164L674.243 340.092V311.614Z",
    fill: "#3395FF",
    stroke: "#28293D",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.243 311.614L649.024 293.686V322.164L674.243 340.092V311.614Z",
    fill: "#3395FF",
    stroke: "#28293D",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.243 311.613L649.024 293.685L674.243 277.213L699.502 293.685L674.243 311.613Z",
    fill: "#DBECFF",
    stroke: "#28293D",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.243 279.395L699.462 261.467V289.945L674.243 307.874V279.395Z",
    stroke: "#B2D6FE",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.243 279.395L649.024 261.467V289.945L674.243 307.874V279.395Z",
    stroke: "#B2D6FE",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.243 279.395L649.024 261.467L674.243 244.994L699.502 261.466L674.243 279.395Z",
    stroke: "#B2D6FE",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.371 398.756C327.487 393.91 341.819 518.947 341.819 518.947H317.4C317.4 518.947 302.576 482.504 302.577 459.4C302.577 442.905 302.577 412.084 315.371 398.756Z",
    fill: "#3395FF",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.747 345.502L367.181 383.256C367.181 383.256 401.765 378.801 410.163 378.133C418.561 377.465 406.967 360.398 406.967 360.398C406.967 360.398 415.891 361.676 417.471 356.696C419.051 351.717 424.528 334.455 424.528 334.455C424.528 334.455 435.814 331.161 427.745 324.314C419.677 317.468 420.881 301.279 420.881 301.279C420.881 301.279 413.581 285.17 406.647 286.75C399.714 288.33 365.055 297.6 369.227 314.703C373.4 331.806 374.747 345.502 374.747 345.502Z",
    fill: "#FFC0A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.883 333.548L412.756 331.292L412.572 323.745C412.572 323.745 418.13 317.644 414.187 310.526C422.241 306.959 429.973 293.187 426.289 280.514C422.605 267.84 412.069 269.715 409.223 273.508C400.238 271.117 395.703 274.34 395.977 278.489C396.25 282.638 359.009 276.749 359.886 305.989C343.44 317.076 363.405 356.896 370.985 359.301C374.923 360.551 383.487 356.783 388.153 354.235C395.506 350.222 396.63 335.789 396.63 335.789C396.63 335.789 388.953 324.994 395.047 318.184C401.142 311.374 405.994 323.701 405.994 323.701L406.883 333.548Z",
    fill: "#202C52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.883 333.548L412.756 331.293C412.756 331.293 414.167 341.036 417.264 342.018C420.36 343.001 424.109 334.895 424.109 334.895L425.76 334.43L426.894 339.932C426.894 339.932 424.595 342.836 422.795 343.773C420.995 344.711 426.29 347.488 427.489 347.32C428.688 347.152 425.82 367.055 418.652 369.113C411.483 371.171 400.043 358.845 400.043 358.845C400.043 358.845 397.617 353.809 400.043 349.14C403.176 343.111 406.883 333.548 406.883 333.548Z",
    fill: "#202C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.745 459.987C326.009 477.647 322.814 499.805 324.66 519.002H453.811C450.425 502.733 449.483 465.315 450.222 445.793C450.96 426.27 457.337 385.995 434.156 379.351C403.557 370.581 390.063 373.336 369.382 374.898C348.701 376.459 312.3 388.255 312.3 408.904C312.3 421.709 313.481 442.327 319.745 459.987Z",
    fill: "#0062CC",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.707 309.38L544.356 273.314C544.356 273.314 548.317 272.192 553.791 297.408C556.982 312.102 554.333 317.358 554.333 317.358L433.093 321.712C433.093 321.712 429.479 318.857 428.935 316.223C428.376 313.52 430.707 309.38 430.707 309.38Z",
    fill: "url(#paint2_linear_1131_40889)",
    stroke: "#E3E4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.341 290.306C558.666 299.674 560.712 321.231 554.085 317.436C555.609 310.44 551.86 283.325 544.051 273.069C548.917 266.103 554.153 281.493 556.341 290.306Z",
    fill: "url(#paint3_linear_1131_40889)",
    stroke: "url(#paint4_linear_1131_40889)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.108,
    cy: 315.77,
    rx: 2.61273,
    ry: 6.43968,
    transform: "rotate(-9.1609 431.108 315.77)",
    fill: "#A0A2CA",
    stroke: "#E3E4EB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 428.131,
    cy: 316.37,
    rx: 3.24259,
    ry: 7.99211,
    transform: "rotate(-9.1609 428.131 316.37)",
    fill: "#D9D9D9",
    stroke: "#A0A2CA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.961,
    cy: 316.656,
    rx: 1.71399,
    ry: 5.70247,
    transform: "rotate(-9.1609 427.961 316.656)",
    fill: "white",
    stroke: "#E3E4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.41 326.806L479.601 313.195C479.601 313.195 473.684 299.215 468.011 297.125C462.331 295.033 459.64 297.168 457.364 296.9C455.086 296.628 444.259 294.741 444.259 304.691C455.173 304.691 454.433 315.386 454.433 315.386C454.433 315.386 451.307 320.928 444.259 320.928C445.934 324.423 446.258 324.886 449.431 326.806C450.809 327.639 461.503 327.776 463.937 326.806C466.371 325.835 471.383 338.749 475.086 342.297C477.27 344.389 486.481 338.461 492.41 326.806Z",
    fill: "#FEB08A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.485 365.574C365.04 361.151 389.484 358.99 405.89 363.879C411.125 365.44 415.551 374.762 415.551 374.762C415.551 374.762 408.129 372.679 384.667 373.692C373.9 374.157 355.923 376.688 355.923 376.688C355.923 376.688 356.111 367.176 358.485 365.574Z",
    fill: "#3395FF",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.698 444.272C421.166 451.437 410.611 380.233 437.525 380.233C453.031 380.233 474.229 385.179 497.707 396.436C480.15 380.233 482.321 363.643 470.597 338.457C476.886 327.301 482.311 323.693 494.046 323.693C503.106 340.645 560.226 407.593 546.588 423.568C531.39 441.372 471.72 435.362 443.698 444.272Z",
    fill: "#3395FF",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.37 396.43C497.37 396.43 501.201 394.131 510.653 401.028",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.632 344.66C473.632 344.66 483.085 331.381 497.82 331.381",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1131_40889",
    x1: 449.048,
    y1: 363.62,
    x2: 133.603,
    y2: 340.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1131_40889",
    x1: 449.048,
    y1: 441.366,
    x2: 228.7,
    y2: 295.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1131_40889",
    x1: 472.697,
    y1: 297.509,
    x2: 484.072,
    y2: 340.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808297"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1131_40889",
    x1: 549.089,
    y1: 273.739,
    x2: 564.783,
    y2: 276.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C8D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1131_40889",
    x1: 547.912,
    y1: 270.989,
    x2: 557.877,
    y2: 317.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C4D8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1131_40889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 519,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKb2);
export default __webpack_public_path__ + "static/media/kb2.7cfb6102bace38844ecfb67f0ade3e1b.svg";
export { ForwardRef as ReactComponent };